// Import centralized API configuration
import { API_URL } from '../config/api.config';

const API_BASE_URL = API_URL;
export const fetchExams = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/exams`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    if (data.success) {
      return data.data;
    } else {
      throw new Error(data.message || 'Failed to fetch exams');
    }
  } catch (error) {
    console.error('Error fetching exams:', error);
    
    // Fallback data for demo purposes when API is not available
    console.warn('Using fallback exams data due to API connectivity issues');
    return [];
  }
};

export const getExamBySlug = async (slug) => {
  try {
    const response = await fetch(`${API_BASE_URL}/exams/slug/${slug}`);
    
    if (!response.ok) {
      if (response.status === 404) {
        throw new Error(`Exam not found: ${slug}`);
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    if (data.success) {
      return data.data;
    } else {
      throw new Error(data.message || 'Failed to fetch exam');
    }
  } catch (error) {
    console.error('Error getting exam by slug:', error);
    
    // Fallback to searching in cached exams
    console.warn('Falling back to searching in cached exams data');
    const exams = await fetchExams();
    const exam = exams.find(exam => exam.slug === slug);
    
    if (!exam) {
      throw new Error(`Exam not found: ${slug}`);
    }
    
    return exam;
  }
};

export const getSubjectById = async (subjectId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/subjects/${subjectId}`);
    
    if (!response.ok) {
      if (response.status === 404) {
        throw new Error(`Subject not found: ${subjectId}`);
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    if (data.success) {
      return data.data;
    } else {
      throw new Error(data.message || 'Failed to fetch subject');
    }
  } catch (error) {
    console.error('Error getting subject by ID:', error);
    
    // Fallback data for demo purposes
    console.warn('Using fallback subject data due to API connectivity issues');
    return {
      _id: subjectId,
      title: `Subject ${subjectId?.slice(-4)}`,
      description: 'Subject details not available',
      exams: []
    };
  }
};

export const fetchSubjectsByExam = async (examSlug) => {
  try {
    // First get the exam by slug to get the ID
    const exam = await getExamBySlug(examSlug);
    
    if (!exam) {
      throw new Error(`Exam not found: ${examSlug}`);
    }
    
    // Then fetch subjects for that exam
    const response = await fetch(`${API_BASE_URL}/exams/${exam._id}/subjects`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    if (data.success) {
      return data.data;
    } else {
      throw new Error(data.message || 'Failed to fetch subjects');
    }
  } catch (error) {
    console.error('Error fetching subjects by exam:', error);
    
    // Fallback data for demo purposes
    console.warn('Using fallback subjects data due to API connectivity issues');
    return [
      {
        _id: 'subject-1',
        title: 'General Awareness',
        slug: 'general-awareness',
        description: 'Current affairs and general knowledge',
        order: 1,
        exams: [{ slug: examSlug }]
      },
      {
        _id: 'subject-2',
        title: 'Mathematics',
        slug: 'mathematics',
        description: 'Quantitative aptitude and mathematics',
        order: 2,
        exams: [{ slug: examSlug }]
      }
    ];
  }
}; 